<template>
  <div class="page-container" v-if="new Date() > dateOfStart">
    <div class="products-stats">
      <div class="products-stats__img-wrap">
        <picture>
          <source :srcset="`https://static.dnipro-m.ua/origin/black-friday/bf-${language}.svg`" media="(min-width: 768px)" />
          <img :src="`https://static.dnipro-m.ua/origin/black-friday/bf-${language}-m.svg`" alt="" />
        </picture>
      </div>
      <div class="products-stats__products">
        <span class="products-stats__products-title">{{ $t('bf_page_stats_products_left') }}</span>
        <div class="products-stats__products-line-wrap">
          <div class="products-stats__products-line">
            <div class="products-stats__products-line-fill"
                 :class="{
                   'red': computedProductsPercent > 0 && computedProductsPercent < 30,
                   'orange': computedProductsPercent >=30 && computedProductsPercent < 50
                 }"
                 :style="{'width': computedProductsPercent + '%'}"></div>
          </div>
          <span class="products-stats__products-line-percents">{{ computedProductsPercent + '%' }}</span>
        </div>
      </div>
      <div class="products-stats__counter">
        <div class="products-stats__counter-title">{{ $t('users_online_now') }}</div>
        <div class="products-stats__counter-value">
          {{ usersOnline | CurrencyFormatter }} {{usersTranslation}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wordFormatter } from '@/mixins/wordFormatter'
import CurrencyFormatter from '@/filters/CurrencyFormatter'
import { mapState } from 'vuex'

export default {
  name: 'ProductsStats',
  mixins: [wordFormatter],
  filters: {
    CurrencyFormatter
  },
  props: {
    dateOfStart: {
      type: String,
      required: true
    },
    dateOfNow: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      language: state => state.translation?.language
    }),
    computedDateOfStart () {
      return new Date(this.dateOfStart)
    },
    computedDateOfNow () {
      return this.dateOfNow ? new Date(this.dateOfNow) : new Date()
    },
    productsPercent () {
      return Math.round((100 - this.$t('stats_products_day') * ((this.computedDateOfNow - this.computedDateOfStart) / 86400000) * 100 / this.$t('stats_products_total')))
    },
    computedProductsPercent () {
      return this.productsPercent < 100 ? this.productsPercent : 100
    },
    usersOnline () {
      return window.config.total_users_online
    },
    usersTranslation () {
      return this.wordFormatter(this.usersOnline, [this.$t('user_pluralize_1'), this.$t('user_pluralize_2'), this.$t('user_pluralize_3')])
    }
  }
}
</script>

<style scoped lang="sass">
.products-stats__img-wrap
  font-size: 0
  +mmax($tablet)
    width: 320px
    max-width: 100%
    margin-bottom: 10px
    text-align: center
.products-stats__counter
  border-radius: 7px
  background: #333
  padding: 10px 20px
  +mmax($tablet)
    display: flex
    align-items: center
    padding: 10px 15px
  &-title
    color: #909090
    position: relative
    white-space: nowrap
    display: flex
    align-items: center
    +mmax($tablet)
      font-size: 13px
    &:before
      content: url("/img/icons/eye-simple.svg")
      vertical-align: middle
      margin-right: 10px
      display: inline-block
      height: 20px
      +mmax($tablet)
        margin-right: 15px
  &-value
    color: #fff
    white-space: nowrap
    padding-left: 30px
    +mmax($tablet)
      font-size: 13px
      padding-left: 10px
.products-stats
  position: relative
  background: #1A1B1D
  border-radius: 10px
  align-items: center
  padding: 10px 20px 25px

  display: flex
  flex-flow: column
  +mmin($tablet)
    padding: 11px 30px
    flex-flow: row nowrap
    justify-content: space-around
  +mmin($tablet--hor)
    padding: 0 30px

  &:before
    content: ''
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    background-image: url('/img/black-friday/shum.png')
    background-size: 120px 120px
    background-repeat: repeat
    pointer-events: none
    mix-blend-mode: screen

.products-stats__products
  width: 100%
  display: flex
  flex-flow: column
  justify-content: center
  align-items: flex-start
  padding: 0
  margin-bottom: 30px
  +mmin($tablet)
    width: 90%
    padding: 0 20px 0 40px
    margin-bottom: 8px
  +mmin($tablet--hor)
    width: 60%
    padding: 0 33px 0 85px

.products-stats__products-title
  display: block
  color: #fff
  font-size: 14px
  margin-bottom: 0
  text-align: left

.products-stats__products-line
  position: relative
  height: 6px
  width: 100%
  border-radius: 9px
  background: rgba(255, 255, 255, .2)

.products-stats__products-line-fill
  position: absolute
  height: 100%
  left: 0
  top: 0
  background: #49D34F
  box-shadow: 0 0 20px rgba(73, 211, 79, 0.5)
  border-radius: 9px
  &.orange
    background: #F5A812
    box-shadow: 0 0 20px rgba(#F5A812, 0.5)
  &.red
    background: #FF2F00
    box-shadow: 0 0 20px rgba(#FF2F00, 0.5)

.products-stats__products-line-wrap
  width: 100%
  display: flex
  flex-flow: row nowrap
  align-items: center
  justify-content: center

.products-stats__products-line-percents
  color: #fff
  font-size: 18px
  margin-left: 25px
</style>

